export default __webpack_public_path__ + "static/media/glossary_tree_books.8e117f52.jpg";